var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrowsers = function SvgIconBrowsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.625 8.625c0-.966.784-1.75 1.75-1.75h2v-2a1.75 1.75 0 0 1 1.75-1.75h13.5a1.75 1.75 0 0 1 1.75 1.75v10.5a1.75 1.75 0 0 1-1.75 1.75h-2v2a1.75 1.75 0 0 1-1.75 1.75h-13.5a1.75 1.75 0 0 1-1.75-1.75zm5.75-3.5v1.75h9.5c.966 0 1.75.784 1.75 1.75v6.5h1.75v-10zm9.25 5.5v-1.75h-13v1.75zm-13 2h13v6.25h-13z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBrowsers;